import logoWhiteSvg from "../../../branding/logo_white.svg";

export function AnimatedLogo({ className = "" }: { className?: string }) {
  return (
    <div className={`relative flex justify-center items-center ${className}`}>
      <img
        src={logoWhiteSvg}
        alt="RADIECE Logo"
        width={320}
        height={80}
        decoding="async"
        className="w-full h-auto object-contain drop-shadow-[0_0_20px_rgba(57,183,233,0.35)] transition-transform duration-500 hover:scale-105"
      />
    </div>
  );
}
